import { BehaviorSubject, catchError, finalize, Observable, tap, throwError } from "rxjs";
import { CustomerDashboardCounter } from "../models/domain/CustomerDashboardCounter";
import { BaseService } from "./base.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { LoadingService } from "./loading.service";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'   // 👈 this registers it automatically app-wide
})

export class CustomerDashboardcounterService extends BaseService<CustomerDashboardCounter> {
  private readonly rowCountSubject: BehaviorSubject<number>;
  public readonly rowCount$: Observable<number>;
  private http: HttpClient;

  constructor(http: HttpClient, loadingService: LoadingService) {
    super(http, `${environment.apiUrl}/v1/dashboard`, loadingService);
    this.http = http;
    this.rowCountSubject = new BehaviorSubject<number>(0);
    this.rowCount$ = this.rowCountSubject.asObservable();
  }

  public getCounter(): Observable<HttpResponse<CustomerDashboardCounter>> {
    return this.httpClient.get<CustomerDashboardCounter>(`${this.baseApiUrl}/AllTableDataCount`, { observe: "response" })
      .pipe(tap(response => {
      }),
        catchError(error => {
          return throwError(() => error); // Make sure to throw the error properly
        }),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      );
  }
}